/**
 * @generated SignedSource<<e1c5b660fef63205848ee4889f6e7898>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPurchaseButton_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowPdpSharedShoppingButtons_viewer">;
  readonly " $fragmentType": "PdpSharedPurchaseButton_viewer";
};
export type PdpSharedPurchaseButton_viewer$key = {
  readonly " $data"?: PdpSharedPurchaseButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPurchaseButton_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPdpSharedShoppingButtons_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b983c20e5e1ad5923d66915d838dda69";

export default node;
